import React, { createContext, useContext, useState } from "react";
import draftToHtml from "draftjs-to-html";
import {ContentState, convertToRaw, EditorState} from "draft-js";
import htmlToDraft from 'html-to-draftjs';
import {TextSectionsDispatch, TextSectionsListContext} from "./TextSectionsListContext";

export const EditorContext = createContext(null);

export const EditorProvider = ({ children }) => {
    const textSection = useContext(TextSectionsListContext);
    const textSectionDispatch = useContext(TextSectionsDispatch);

    const contentBlock = htmlToDraft('');
    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
    const [editorState, setEditorState] = useState(EditorState.createWithContent(contentState));

    const currentSection = textSection ? textSection.find((section) => section.active) : null;

    const onEditorStateChange = (newState) => {
        setEditorState(newState);
        const rawContent = convertToRaw(newState.getCurrentContent());
        const html = draftToHtml(rawContent);
        // setHtmlContent(html);
        textSectionDispatch({
            type: "updateTextSectionData",
            payload: {
                index: currentSection.index,
                value: html,
                rawContent : rawContent.blocks.map(block => block.text).join(' ')
            }
        });
    };


    return (
        <EditorContext.Provider
            value={{
                editorState,
                onEditorStateChange,
            }}
        >
            {children}
        </EditorContext.Provider>
    );
};

export const useEditorContext = () => useContext(EditorContext);